import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Printer, Clock, Award, Sparkles, Palette, MessageCircle } from "lucide-react";

const features = [
  { icon: Printer, title: "Moderne Drucker", description: "FDM-Druck mit präzisen Maschinen. Gute Qualität, reproduzierbar." },
  { icon: Clock, title: "Schnell & pünktlich", description: "Klare Timelines, offene Kommunikation wenn sich etwas ändert." },
  { icon: Award, title: "Qualitätsanspruch", description: "Wenn das Ergebnis nicht passt, wird nachgebessert. Selbstverständlich." },
  { icon: Sparkles, title: "Nachbearbeitung", description: "Schleifen, Entgraten, sauberes Finish auf Wunsch." },
  { icon: Palette, title: "Verschiedene Materialien", description: "PLA, PETG, ABS, FLEX. Besondere Filamente auf Anfrage." },
  { icon: MessageCircle, title: "Direkter Kontakt", description: "Kein Ticketsystem. Kurze Wege, klare Absprachen." },
];

const FeatureSet = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <section ref={ref} className="bg-[#1d1d1f] py-24">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="text-[13px] font-medium text-white/40 uppercase tracking-widest mb-3">3D-Druck</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">Was den Unterschied macht.</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {features.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : {}}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="bg-[#1d1d1f] p-8 hover:bg-white/5 transition-colors duration-300 group"
            >
              <f.icon className="w-5 h-5 text-white/35 mb-5 group-hover:text-white/60 transition-colors" />
              <h3 className="text-[16px] font-semibold text-white mb-2">{f.title}</h3>
              <p className="text-[14px] text-white/45 leading-relaxed">{f.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSet;
